import React, { useContext } from 'react';
import Dialog from '../../../../../../BaseComponents/Dialog/EDDialog';
import FakturaBilderComponent from '../FakturaBilderComponent';
import { makeStyles } from 'tss-react/mui';
import FunctionMenu from '../../../../_Common/Components/FunctionMenu/FunctionMenu/FunctionMenu';
import FunctionItem from '../../../../_Common/Components/FunctionMenu/FunctionItem/FunctionItem';
import { IFakturaBildPDF } from '../../../../../../Components/ExportToPDF/ExportToPDFArgumentTypes';
import { printFakturabild } from '../../../../Ekonomi/Rutiner/EkonomiskAnalys/Components/VerifikationModal/verifikationUtils';
import FakturabilderQuery from '../Queries/Fakturabilder/FakturabilderQuery';
import ExportToPDF from '../../../../../../Components/ExportToPDF/ExportToPDF';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

interface IProps {
  id: string;
  open: boolean;
  onClose: () => void;
  headerBottomArea?: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const useStyles = makeStyles()(
  theme =>
    ({
      dialogContentWrapper: {
        margin: 0,
        height: '100%',
      },
      dialogPaper: {
        height: '100%',
        width: 'calc(100% - 500px)',
        [theme.breakpoints.up('md')]: {
          maxHeight: 'calc(100% - 16px)',
        },
        [theme.breakpoints.down('lg')]: {
          width: '100%',
        },
      },
      dialogPaperScrollPaper: {},
      dialogContent: {
        height: '100%',
      },
      functionMenuContainer: {
        position: 'relative',
        right: theme.spacing(-5),
        bottom: theme.spacing(-2.5),
      },
    } as const)
);

const LeverantorFakturaModal: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();

  const { activeDatabase } = useContext(ActiveDatabaseContext);

  return (
    <FakturabilderQuery id={props.id}>
      {fakturabilder => (
        <ExportToPDF<IFakturaBildPDF>>
          {exportFakturaBildToPDF => (
            <Dialog
              fullWidth
              maxWidth="xl"
              onClose={props.onClose}
              open={props.open}
              title={props.title ?? 'Fakturabilder'}
              subtitle={props.subtitle}
              classes={{
                contentWrapper: classes.dialogContentWrapper,
                paper: classes.dialogPaper,
                paperScrollPaper: classes.dialogPaperScrollPaper,
                content: classes.dialogContent,
              }}
              footerActions={[{ label: 'Stäng', onClick: props.onClose }]}
              headerTools={
                <div className={classes.functionMenuContainer}>
                  <FunctionMenu id="verifikationFakturabild" highEmphasis>
                    <FunctionItem
                      iconType="print"
                      onClick={() => {
                        printFakturabild(
                          exportFakturaBildToPDF,
                          fakturabilder.bilder,
                          fakturabilder.defAnkVernr ?? '',
                          fakturabilder.xml,
                          activeDatabase ?? '',
                          fakturabilder.defAnkVernr != null
                            ? fakturabilder.bokfDatum ?? ''
                            : '',
                          fakturabilder.defAnkVernr != null
                            ? fakturabilder.journalNr ?? ''
                            : '',
                          fakturabilder.skannadSvefaktura
                        );
                      }}
                    >
                      Skriv ut
                    </FunctionItem>
                  </FunctionMenu>
                </div>
              }
              headerBottomArea={props.headerBottomArea}
            >
              <FakturaBilderComponent
                extraBottomPadding={false}
                noFullscreenToggle={false}
                id={props.id}
                config={{ fullPage: true, parents: [] }}
                noPadding
                verifikationsNr={fakturabilder.defAnkVernr}
                useWheelToScroll={false}
                ignoreFloatingMenu
              />
            </Dialog>
          )}
        </ExportToPDF>
      )}
    </FakturabilderQuery>
  );
};

export default LeverantorFakturaModal;
